export const RouteLinks = {
    dictionary:'dictionary',
    lang:'lang',
    createPage:'page/create',
    pages:'pages',
    createCategory:'category/create',
    categories:'categories',
    createProduct:'product/create',
    products:'products',
    users:'users',
    sliders:'sliders',
    createSlider:'slider/create',
    posts:'posts',
    services:'service',
    createPost:'post/create',
    createServices:'service/create',
    team:'team',
    createTeam:'team/create',
    gallery:'gallery',
    createGallery:'gallery/create',
    settings:'settings',
    editSettings:'settings/edit/1',
    registry:'registry',
    createRegistry:'registry/create',
    members:'members',
    createMembers:'members/create',
    colors:'options/colors',
    sizes:'options/sizes',
    extras:'options/extras',
    materials:'options/materials',
    printType:'options/print-type',
}